function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferenceRule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M120 84H56v-8h64zm0-28H56v8h64zm-64 48h32v-8H56zm88 64H48V24h96v35.234a26.3 26.3 0 0 1 8-3.455V16H40v160h112v-50.415l-8 8zm26.845-73.955-2.828 2.829-.017-.017-52.355 52.355-33.143 8.286 8.286-33.143 55.167-55.2c6.862-6.863 18.028-6.863 24.89 0s6.863 18.028 0 24.89M113.6 139.943l42.35-42.35-13.513-13.574-42.38 42.38zm-20.102 6.56 12.278-3.07-9.209-9.209zm71.69-71.691c-3.583-3.583-9.315-3.737-13.083-.46l-4.01 4.01 13.512 13.575 4.042-4.042c3.275-3.768 3.122-9.5-.461-13.083",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenceRule);
export default __webpack_public_path__ + "static/media/referenceRule.0564beefcd6d08df7a37bda8bd2d09a3.svg";
export { ForwardRef as ReactComponent };